export default {
  light: '0 1px 2px 0px rgba(0, 0, 0, 0.1)',
  regular: '0 1px 2px 0px rgba(0, 0, 0, 0.2)',
  diffused: '0 2px 16px 4px rgba(0, 0, 0, 0.1)',
  bold: '0 2px 2px 2px rgba(0, 0, 0, 0.3)',
  focus: '0 0 6px 0 rgba(71, 199, 154, 0.5)',
  error: '0 0 6px 0 rgba(255, 120, 120, 0.5)'
}
